export const getCountry = () => {
  if (location && location.hostname) {
    const allowedCountries = ['br', 'ar', 'ec', 'co', 'pe', 'cl', 'do'];
    const currentCountry = location.hostname
      .toLowerCase()
      .split('.')
      .pop() as string;

    return allowedCountries.includes(currentCountry) ? currentCountry : 'br';
  }

  return 'br';
};

export const getWithDotComByCountry = (c: string) => {
  const countryNotCom = ['cl'];

  return countryNotCom.indexOf(c) === -1 ? '.com.' : '.';
};

export const getCountryName = (acronym: string): string => {
  const names = {
    br: 'Brasil',
    ar: 'Argentina',
    ec: 'Equador',
    co: 'Colômbia',
    pe: 'Peru',
    cl: 'Chile',
    do: 'República Dominicana',
  };

  return names[acronym as keyof typeof names];
};
